<template>
  <div
    class="step-progress-bar card"
    :class="{
      'mobile': isMobile,
      'show': isMobile && mobileState,
      'hide': isMobile && !mobileState,
      'position-with-nav': !slideProgressBar,
      'position-without-nav': slideProgressBar,
    }"
  >
    <div class="visit-info-bar">
      <div
        v-if="isMobile"
        class="mobile-close"
      >
        <span @click="$emit('close_bar')">
          <svg svg-inline="" role="presentation" focusable="false" width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M31.6 15.4L15.4 31.6m0-16.2l16.3 16.3" stroke="currentColor" fill="none"/></svg>
        </span>
      </div>
      <div class="progress-info car">
        <car-block
          v-if="car"
          class="progress-bar"
          mode="visit"
          :car="car"
        />
      </div>
      <div class="progress-info car-services">
        <div class="info-wrapper">
          Zakres usług
          <p>
            <template v-if="Array.isArray(selectedServices) && selectedServices.length">
              <span
                :key="index"
                v-for="(service, index) in selectedServices"
              >
                {{ service.name }}
                <span
                  v-if="service.description"
                  v-tooltip.top="{ content: service.description, classes: 'car-service-tooltip' }"
                  class="car-service-info-icon-wrapper">
                  <svg svg-inline="" class="car-service-info-icon" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M24.8 29.8h-2V16.3c0-.3-.3-.6-.6-.6h-6.6c-.3 0-.6.3-.6.6l.3 3.7h2v9.8h-2c-.4 0-.6.3-.6.601v3c0 .3.3.6.6.6h9.4c.399 0 .6-.3.6-.6v-3c0-.201 0-.601-.5-.601zM19.8 6a3.8 3.8 0 1 1 0 7.6 3.8 3.8 0 0 1 0-7.6z" fill="#111"/></svg>
                </span>
                {{ index === selectedServices.length - 1 ? '' : ',' }}
              </span>
            </template>
            <template v-else>
              -
            </template>
          </p>
        </div>
      </div>
      <div class="progress-info visit-cost">
        <div class="info-wrapper">
          Koszt wizyty
          <p>
            {{ servicesCost ? `${servicesCost.toFixed(2).replace('.', ',')} PLN` : '-' }}
          </p>
        </div>
      </div>
      <div class="progress-info visit-date">
        <div class="info-wrapper">
          Termin wizyty
          <p>
            {{ selectedVisitDate ? formattedVisitDate : '-' }}
          </p>
        </div>
      </div>
      <div class="progress-info service-station">
        <div
          class="info-wrapper"
          v-if="!selectedPartner"
        >
          Partner Serwisowy
          <p>
            -
          </p>
        </div>
        <service-station-block
          v-else
          class="visit"
          :show-details="false"
          :service-station="selectedPartner"
        />
      </div>
    </div>
    <div class="visit-progress-bar">
      <div
        class="progress-button checked"
        @click="withLogin !== undefined ? redirect(paths.car, true) : null"
      >
        <span class="tick-icon-wrapper">
          <svg svg-inline="" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M36 8.4l-2.1-1.7c-.3-.2-.6-.2-.9.1L15.5 26.4l-9-5.5c-.3-.2-.6-.1-.8.1l-1.8 2c-.3.3-.2.7.1.9l11.8 9.4c.3.2.7.2.9-.1L36.1 9.3c.2-.2.1-.6-.1-.9z" fill="#111"/></svg>
        </span>
        Wybór samochodu
        <div class="arrow" />
      </div>
      <div
        class="progress-button"
        @click="redirect(paths.partner, selectedPartner)"
        :class="{
          'checked': selectedPartner,
          'active': activeButton === 'station',
        }"
      >
        <span v-if="selectedPartner" class="tick-icon-wrapper">
          <svg svg-inline="" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M36 8.4l-2.1-1.7c-.3-.2-.6-.2-.9.1L15.5 26.4l-9-5.5c-.3-.2-.6-.1-.8.1l-1.8 2c-.3.3-.2.7.1.9l11.8 9.4c.3.2.7.2.9-.1L36.1 9.3c.2-.2.1-.6-.1-.9z" fill="#111"/></svg>
        </span>
        Partner Serwisowy
        <div class="arrow" />
      </div>
      <div
        class="progress-button"
        @click="redirect(paths.services, selectedServices)"
        :class="{
          'checked': selectedServices && selectedPartner,
          'active': activeButton === 'service',
        }"
      >
        <span v-if="selectedServices" class="tick-icon-wrapper">
          <svg svg-inline="" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M36 8.4l-2.1-1.7c-.3-.2-.6-.2-.9.1L15.5 26.4l-9-5.5c-.3-.2-.6-.1-.8.1l-1.8 2c-.3.3-.2.7.1.9l11.8 9.4c.3.2.7.2.9-.1L36.1 9.3c.2-.2.1-.6-.1-.9z" fill="#111"/></svg>
        </span>
        Usługi serwisowe
        <div class="arrow" />
      </div>
      <div
        class="progress-button"
        @click="redirect(paths.visitDate, selectedVisitDate)"
        :class="{
          'checked': selectedVisitDate && selectedServices.length && selectedPartner,
          'active': activeButton === 'date',
        }"
      >
        <span v-if="selectedVisitDate" class="tick-icon-wrapper">
          <svg svg-inline="" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M36 8.4l-2.1-1.7c-.3-.2-.6-.2-.9.1L15.5 26.4l-9-5.5c-.3-.2-.6-.1-.8.1l-1.8 2c-.3.3-.2.7.1.9l11.8 9.4c.3.2.7.2.9-.1L36.1 9.3c.2-.2.1-.6-.1-.9z" fill="#111"/></svg>
        </span>
        Termin wizyty
        <div class="arrow" />
      </div>
      <div
        class="progress-button"
        @click="redirect(paths.confirmation, selectedPartner && registeredVisit && selectedVisitDate && selectedServices.length)"
        :class="{
          'checked': registeredVisit && selectedVisitDate && selectedServices.length && selectedPartner,
          'active': activeButton === 'confirm',
        }"
      >
        <span v-if="registeredVisit" class="tick-icon-wrapper">
          <svg svg-inline="" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M36 8.4l-2.1-1.7c-.3-.2-.6-.2-.9.1L15.5 26.4l-9-5.5c-.3-.2-.6-.1-.8.1l-1.8 2c-.3.3-.2.7.1.9l11.8 9.4c.3.2.7.2.9-.1L36.1 9.3c.2-.2.1-.6-.1-.9z" fill="#111"/></svg>
        </span>
        Dane kontaktowe
        <div class="arrow" />
      </div>
      <div
        class="progress-button"
        :class="{
          'active': activeButton === 'confirmed',
          'checked': activeButton === 'confirmed' && registeredVisit,
        }"
      >
        <span v-if="registeredVisit" class="tick-icon-wrapper">
          <svg svg-inline="" role="presentation" focusable="false" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M36 8.4l-2.1-1.7c-.3-.2-.6-.2-.9.1L15.5 26.4l-9-5.5c-.3-.2-.6-.1-.8.1l-1.8 2c-.3.3-.2.7.1.9l11.8 9.4c.3.2.7.2.9-.1L36.1 9.3c.2-.2.1-.6-.1-.9z" fill="#111"/></svg>
        </span>
        Potwierdzenie
        <div class="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import CarBlock from '~/CarBlock';
import ServiceStationBlock from '~/ServiceStationBlock';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
  props: {
    mobileState: {
      type: Boolean,
      default: false,
    },
    slideProgressBar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CarBlock,
    ServiceStationBlock,
  },
  computed: {
    ...mapGetters({
      myCars: 'myCars/getMyCars',
      allCars: 'brand/getSpecificModels',
      selectedLicensePlate: 'visit/selectedLicensePlate',
      selectedCarModelID: 'visit/selectedCarModelID',
      selectedVin: 'visit/selectedVin',
      selectedVisitDate: 'visit/selectedVisitDate',
      selectedServices: 'visit/selectedServices',
      selectedPartner: 'visit/selectedPartner',
      registeredVisit: 'visit/registeredVisit',
      authStatus: 'auth/getAuthStatus',
    }),
    withLogin() {
      return this.authStatus.loggedIn;
    },
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    paths() {
      const defaultPath = (id, name, mode) => {
        if (mode === 'edit') {
          return `/dashboard/visits/edit/${id}/${name}`;
        } if (this.noAuthMode) {
          return `/no_auth/visit/${name}`;
        }
        return `/dashboard/visits/new/${id}/${name}`;
      };
      const carId = this.$route.params.id;
      const mode = () => {
        const isEdit = this.$route.path.includes('edit');
        const isNoAuth = this.$route.path.includes('no_auth');

        if (isEdit) {
          return 'edit';
        } if (isNoAuth) {
          return 'no_auth';
        }
        return '';
      };

      return {
        car: '/dashboard/mycars',
        partner: defaultPath(carId, 'station', mode()),
        services: defaultPath(carId, 'service', mode()),
        visitDate: defaultPath(carId, 'date', mode()),
        confirmation: defaultPath(carId, 'confirm', mode()),
      };
    },
    noAuthMode() {
      return this.$route.path.includes('no_auth');
    },
    servicesCost() {
      if (Array.isArray(this.selectedServices) && this.selectedServices.length) {
        return this.selectedServices
          .map(service => service.grossPrice)
          .reduce((a, b) => a + b);
      }
      return null;
    },
    formattedVisitDate() {
      const { day, time } = this.selectedVisitDate;
      if (this.selectedVisitDate) {
        return `${dayjs(day).format('DD.MM.YYYY')} ${time}`;
      }
      return null;
    },
    activeButton() {
      const pathIncludes = name => this.$route.path.includes(name);

      if (pathIncludes('station')) {
        return 'station';
      } if (pathIncludes('service')) {
        return 'service';
      } if (pathIncludes('date')) {
        return 'date';
      } if (pathIncludes('confirm') && !pathIncludes('confirmed')) {
        return 'confirm';
      } if (pathIncludes('confirm') && pathIncludes('confirmed')) {
        return 'confirmed';
      }

      return null;
    },
    car() {
      const {
        allCars, myCars, selectedLicensePlate, selectedVin,
      } = this;

      if (!this.noAuthMode) {
        return myCars.find(car => selectedLicensePlate === car.licensePlate && selectedVin === car.vin);
      }
      return {
      // eslint-disable-next-line
        ...allCars.find(car => car.id == this.selectedCarModelID),
        vin: this.selectedVin,
        licensePlate: this.selectedLicensePlate,
      };
    },
  },
  methods: {
    redirect(path, condition) {
      if (!this.$route.path.includes('confirmed')) {
        if (condition) {
          this.$router.push({ path });
        }
      }
    },
  },
};
</script>
